module.exports = __webpack_public_path__ + "assets/9935deab980822a9354b5cd22d79285d.svg";